// Uses @sentry/react (works in any JS runtime for capture/init via fetch transport)
// rather than @sentry/node, which pulls Node-only APIs incompatible with Cloudflare Workers.
import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentryServer() {
  if (initialized) return;
  const dsn = process.env.SENTRY_DSN;
  if (!dsn) {
    if (process.env.NODE_ENV !== "production") {
      console.info("[sentry] SENTRY_DSN not set — server error reporting disabled.");
    }
    return;
  }
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    release: process.env.SENTRY_RELEASE,
    tracesSampleRate: 0,
    defaultIntegrations: false,
    sendDefaultPii: false,
  });
  initialized = true;
}

export function captureServerException(error: unknown, context: Record<string, unknown> = {}) {
  if (!process.env.SENTRY_DSN) return;
  initSentryServer();
  Sentry.captureException(error, { extra: context });
  try {
    void Sentry.flush(2000);
  } catch {
    /* no-op */
  }
}
